module.exports = __webpack_public_path__ + "img/public/SiteIcons/carTypeIcon.svg?a3eea8c4";